import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { Action, IntentProject } from "types/generated";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import DropdownMenuEllipsis from "ds/components/DropdownMenu/Ellipsis";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import CopyFieldDropdownMenuItem from "components/CopyField/DropdownMenuItem";
import useUnlockIntentProject from "shared/IntentProject/useUnlockIntentProject";
import useIntentProjectDownloadHcl from "shared/IntentProject/useDownloadHcl";
import { checkAllowedAction } from "utils/access";

import { showCreateIntentProjectDrawer } from "../../CreateIntentProjectDrawer";
import { showIntentProjectDeleteConfirmation } from "../../DeleteConfirmation";

const IntentProjectsTableRowActionsCell = ({
  item: intentProject,
  ...cellProps
}: TableSimpleCellProps<IntentProject>) => {
  const { unlockIntentProject, loading: unlockLoading } = useUnlockIntentProject();
  const { downloadHcl, loading: downloadHclLoading } = useIntentProjectDownloadHcl();

  const canUpdateIntentProject = checkAllowedAction(intentProject, Action.IntentProjectUpdate);
  const canDeleteIntentProject = checkAllowedAction(intentProject, Action.IntentProjectDelete);
  const canUnlockIntentProject = checkAllowedAction(intentProject, Action.IntentProjectUnlock);

  const handleEdit = () => {
    showCreateIntentProjectDrawer({
      project: intentProject,
    });
  };

  const handleDelete = () => {
    showIntentProjectDeleteConfirmation({
      id: intentProject.id,
      name: intentProject.name,
    });
  };

  const handleUnlock = () => {
    unlockIntentProject(intentProject.id);
  };

  const handleDownloadHcl = () => {
    downloadHcl(intentProject.id);
  };

  return (
    <TableSimpleCell {...cellProps}>
      <DropdownMenuEllipsis tooltip="Intent Project actions">
        <DropdownMenuItem
          onAction={handleEdit}
          isDisabled={!canUpdateIntentProject.result}
          tooltip={canUpdateIntentProject.message}
          tooltipPlacement="left"
        >
          Edit
        </DropdownMenuItem>
        <CopyFieldDropdownMenuItem title="Copy ID" value={intentProject.id} />
        <DropdownMenuItem onAction={handleDownloadHcl} isDisabled={downloadHclLoading}>
          Download HCL file(s)
        </DropdownMenuItem>
        {intentProject.isLocked && (
          <DropdownMenuItem
            onAction={handleUnlock}
            isDisabled={unlockLoading || !canUnlockIntentProject.result}
            tooltip={canUnlockIntentProject.message}
            tooltipPlacement="left"
          >
            Unlock
          </DropdownMenuItem>
        )}
        <DropdownMenuItem
          onAction={handleDelete}
          danger
          isDisabled={!canDeleteIntentProject.result}
          tooltip={canDeleteIntentProject.message}
          tooltipPlacement="left"
        >
          Delete
        </DropdownMenuItem>
      </DropdownMenuEllipsis>
    </TableSimpleCell>
  );
};

export default IntentProjectsTableRowActionsCell;
